<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import globalMethods from './mixins/global-methods';

export default {
  name: 'App',
  mixins: [
    globalMethods,
  ],
  methods: {
  },
};
</script>

<style src="./styles/vuetify.min.css"></style>

<style>
@import 'https://fonts.googleapis.com/icon?family=Material+Icons';
@import 'https://fonts.googleapis.com/css?family=Montserrat:100,200';
html, body {
    width: 100%;
    height: 100%;
    background-color: #141c29;
    overflow: hidden;
}
#app {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  height: 100%;
  font-family: 'Montserrat', sans-serif;
  font-weight: 100;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue